import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider } from 'antd';

import { LanguageDropdown } from 'components/Navbar/components/LanguageDropdown/LanguageDropdown';
import NavbarBtns from 'components/Navbar/components/NavbarBtns';
import useOpenPricing from 'assets/CustomHooks/use-open-pricing';
import bookDemo from 'helpers/bookDemo';

export function NavbarActions({ isHomepage, isLoginPage, isSignupPage, toggleLogin, toggleSignup }) {
  const { t } = useTranslation('common');
  const openPricing = useOpenPricing();

  const accountType = JSON.parse(localStorage.getItem('user'))?.user?.account_type;

  return (
    <div className="navbar-unlogged-desktop__buttons">
      <div className="d-flex align-items-center">
        {!isHomepage && accountType === 'influencer' && <NavbarBtns />}
        <div className="d-flex align-items-center">
          <LanguageDropdown isUnlogged />
          {!isLoginPage && !isSignupPage && (
            <>
              <Divider type="vertical" className="mt-0" />
              <div
                className="ml-3 mr-3 cursor-pointer"
                onClick={() => {
                  openPricing({ button_name: 'navbar_unlogged_pricing' });
                }}
              >
                {t('navbar_logged.dropdown.pricing')}
              </div>
              <Button
                onClick={toggleLogin}
                type="text"
                style={{ fontSize: 16 }}
                className="navbar-unlogged-desktop__login mr-3 d-flex align-items-center"
              >
                {t('home_headers.login')}
              </Button>
            </>
          )}

          <Button onClick={bookDemo} type="default">
            {t('navbar_unlogged.demo')}
          </Button>

          {!isLoginPage && !isSignupPage && (
            <Button onClick={toggleSignup} id="header_publish-opportunity" type="primary" className="ml-3">
              {t('navbar_unlogged.startForFree')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
